import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const Notification = (status, message) => {
  const handleMessageNotification = (message, messageDefault) =>
    message !== undefined ? message : messageDefault;
  switch (status) {
    case 200:
    case 201:
      toast.success(
        handleMessageNotification(message, 'Operação realizada com sucesso!')
      );
      break;
    case 403:
    case 401:
      toast.error(
        handleMessageNotification(
          message,
          'Permissão negada, verifique as permissões com o administrador do sistema!'
        )
      );
      break;
    case 500:
      toast.error(
        handleMessageNotification(
          message,
          'Erro inesperado, por gentileza contate o suporte!'
        )
      );
      break;
    case 404:
      toast.warn(
        handleMessageNotification(
          message,
          'A página desejada não foi encontrada, por gentileza contate o suporte!'
        )
      );
      break;
    default:
      break;
  }
};
